export default class MylesColors {
  static mylesGreen() {
    return '#04DC5A';
  }

  static mylesGray() {
    return '#767678';
  }
}
